import React, { useEffect, useMemo, useState } from 'react'

import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'
import { connect } from 'react-redux'
import { removeRegionFromPath } from 'lib/url/searchUrlUtils'
import LayoutContainer from '../LayoutContainer'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TabButton from 'components/Luxkit/Tabs/TabButton'
import TabButtonsGroup from 'components/Luxkit/Tabs/TabButtonsGroup'
import LinkBox from './LinkBox'
import ErrorBoundary from '../ErrorBoundary'

const Root = styled.div`
  display: flex;
  text-align: left;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

interface Props {
  currentRegionCode: string;
  grandTitle: string | undefined;
  links: Array<App.ContentLinkBox> | null | undefined;
}

function LinkBoxes({ links, grandTitle }: Props) {
  const sectionKeys:Set<string> = useMemo(() => {
    return links ? new Set(links.map((s) => s.title)) : new Set()
  }, [links])
  const [activeNavItem, setActiveNavItem] = useState<string | null>(null)
  const [activeLinks, setActiveLinks] = useState< Array<App.ContentLinkBox> | null>(null)

  useEffect(() => {
    let valueToSet:string | null = null
    if (!activeNavItem) {
      valueToSet = sectionKeys.values().next().value
    } else {
      valueToSet = activeNavItem
    }
    setActiveNavItem(valueToSet)
    const alnk = links ? links.filter((l) => l.title == valueToSet) : null
    setActiveLinks(alnk)
  }, [links, activeNavItem, sectionKeys])

  if (links == null || Object.keys(links).length === 0) {
    return null
  }
  return (<Root>
    <ErrorBoundary>
      <LayoutContainer>
        <VerticalSpacer gap={20}>
          <Heading variant="heading3">{grandTitle}</Heading>
          {sectionKeys.size > 1 && <TabButtonsGroup>
            {Array.from(sectionKeys).map((sectionTitle) => {
              return <TabButton
              key={sectionTitle}
              size="medium"
              isActive={sectionTitle === activeNavItem}
              onClick={() => { setActiveNavItem(sectionTitle) }}
            >
                {sectionTitle}
              </TabButton>
            })}
          </TabButtonsGroup>}
          <CSSBreakpoint max="tablet">
            <LinkBox linkBoxes={activeLinks} maxDefaultHeight={200} />
          </CSSBreakpoint>
          <CSSBreakpoint min="desktop">
            <LinkBox linkBoxes={activeLinks} maxDefaultHeight={300} />
          </CSSBreakpoint>
        </VerticalSpacer>
      </LayoutContainer>
    </ErrorBoundary>
  </Root>)
}

function mapStateToProps(state: App.State):Props {
  const pathWithoutRegion = removeRegionFromPath(state.router.location.pathname)
  const container:App.ContentLinkBoxContainer | null = state.content.searchFooterLinkBox && pathWithoutRegion in state.content.searchFooterLinkBox ? state.content.searchFooterLinkBox[pathWithoutRegion] : null

  return {
    currentRegionCode: state.geo.currentRegionCode,
    grandTitle: container?.title,
    links: container?.linkBoxJson?.links,
  }
}

export default connect(mapStateToProps)(LinkBoxes)
